import * as React from 'react'

import { sendStep1SignForm } from '../../steps/step1/form/api'

export const useSmsRetry = () => {
	const [{ countdown, isRunning }, setTimer] = React.useState({
		countdown: 30,
		isRunning: true,
	})
	const interval = React.useRef(0)

	React.useEffect(() => {
		if (!isRunning) {
			clearInterval(interval.current)
			return undefined
		}

		interval.current = window.setInterval(() => {
			setTimer((p) => ({ ...p, countdown: p.countdown - 1 }))
		}, 1000)

		return () => {
			clearInterval(interval.current)
		}
	}, [isRunning])

	const handleReset = React.useCallback(async () => {
		try {
			await sendStep1SignForm()
			setTimer({ countdown: 30, isRunning: true })
		} catch {
			//
		}
	}, [])

	React.useEffect(() => {
		if (countdown <= 0) setTimer({ countdown: 0, isRunning: false })
	}, [countdown])

	return {
		retry: handleReset,
		isRunning,
		text: isRunning
			? `Отправить код повторно через 0:${countdown >= 10 ? countdown : `0${countdown}`}`
			: 'Отправить код повторно',
	}
}
